<template>
  <section class="hmseries products page_content">
    <div class="cosmetics_banner">
      <img src="/assets/img/HM960x330-banner-eng.png" alt="HAIRMEDICシリーズ">
    </div>
    <div class="row_cosmetics">
      <a href="https://scandinavianbeauty.jp/collections/hair-medic-%E3%83%98%E3%82%A2%E3%83%A1%E3%83%87%E3%82%A3%E3%83%83%E3%82%AF/products/hm%E3%82%B9%E3%82%AB%E3%83%AB%E3%83%97%E3%82%B7%E3%83%A3%E3%83%B3%E3%83%97%E3%83%BC-300ml">
        <div>
          <img src="/assets/img/HMShampoo-800x800-new.jpg" alt="HMスカルプ シャンプー">
        <p>
          <strong>HM Scalp Shampoo (300mL)</strong>              <!-- HMスカルプエッセンスと同成分を配合した低刺激の天然アミノ酸系シャンプーです。    ノンシリコンなのにキシまず、洗いながらダメージを補修し、ツヤとハリのある健やかな髪再生をサポートします。マイルドな使用感と洗い上がりの軽やかさにこだわりました。-->
        </p>
      </div>
      </a>

      <a href="https://scandinavianbeauty.jp/collections/hair-medic-%E3%83%98%E3%82%A2%E3%83%A1%E3%83%87%E3%82%A3%E3%83%83%E3%82%AF/products/hm%E3%82%B9%E3%82%AB%E3%83%AB%E3%83%97%E3%83%88%E3%83%AA%E3%83%BC%E3%83%88%E3%83%A1%E3%83%B3%E3%83%88-300ml">
        <div>
          <img src="/assets/img/HMTreatment-800x800-new.jpg" alt="HMスカルプ トリートメント">
        <p>
          <strong>HM Sacalp Treatment (300mL)</strong> <!-- HMスカルプエッセンスと同成分を配合した髪と地肌をうるおすトリートメントです。             地肌の皮脂とうるおい不足をケアしながら、毛髪ダメージを補修。ノンシリコン処方のトリートメント剤でやさしく保護しながら、髪と頭皮を健やかに整えます。-->
        </p>
      </div>
      </a>

      <a href="https://scandinavianbeauty.jp/collections/hair-medic-%E3%83%98%E3%82%A2%E3%83%A1%E3%83%87%E3%82%A3%E3%83%83%E3%82%AF/products/hm%E3%82%B9%E3%82%AB%E3%83%AB%E3%83%97%E3%82%A8%E3%83%83%E3%82%BB%E3%83%B3%E3%82%B9-100ml">
        <div>
          <img src="/assets/img/HMEssence-800x800-new.jpg" alt="HMスカルプ エッセンス">
        <p>
          <strong>HM Scalp Essence (100mL)</strong> <!-- 健康なヘアサイクルの鍵は、バルジ領域という理論から誕生したスカルプエッセンスです。             抜け毛の原因といわれるタンパク質FGF-5を抑えて、髪本来のサイクルを助けるタモギ茸エキスとカラギーナンのWの成分を配合。原料は食べ物や植物成分から抽出しているので安心です。-->
        </p>
      </div>
      </a>

      <a href="https://scandinavianbeauty.jp/collections/hair-medic-%E3%83%98%E3%82%A2%E3%83%A1%E3%83%87%E3%82%A3%E3%83%83%E3%82%AF/products/hm-%E3%82%B9%E3%82%AB%E3%83%AB%E3%83%97%E3%82%A8%E3%83%83%E3%82%BB%E3%83%B3%E3%82%B9-pro">
        <div>
          <img src="/assets/img/HM_new_essensepro_1024x1024@2x.webp" alt="HMスカルプ エッセンス PRO">
        <p>
          <strong>HM Scalp Essence PRO (100mL)</strong> <!-- 健康なヘアサイクルの鍵は、バルジ領域という理論から誕生したスカルプエッセンスです。             抜け毛の原因といわれるタンパク質FGF-5を抑えて、髪本来のサイクルを助けるタモギ茸エキスとカラギーナンのWの成分を配合。原料は食べ物や植物成分から抽出しているので安心です。-->
        </p>
        </div>
      </a>


      <!--
      <a href="https://scandinavianbeauty.jp/products/%E3%83%98%E3%82%A2%E3%83%A1%E3%83%87%E3%82%A3%E3%83%83%E3%82%AF%E3%82%B0%E3%83%AD%E3%83%BC">
        <div>
          <img src="/assets/img/HM_360x.webp" alt="HM GROW">
          <p>
            <strong>HAIRMEDIC GROW</strong>
            <!--           HAIRMEDICシステム専用の業務用の保湿効果が高いトリートメントミストです。            カリウム・カルシウム・マグネシウムなどミネラルを豊富に含んだ海洋深層水を使用し、HAIRMEDICシステムでのトリートメント時に使用することで育毛促進・脱毛抑制し、頭皮＆毛髪を健康な状態に整えます。 -->
          </p>
        </div>
      </a>
    </div>
  </section>
</template>

<script>

 export default {
   name: 'hmseries'
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;
 a {
   text-decoration: none;
 }

 .hmseries {
   /* margin-top: 80px; */
 }

 @media (max-width: 600px) {
   .hmseries {
     /* margin-top: 20px; */
   }
 }

 .products {
   margin-top: 80px;
 }
 @media (max-width: 600px) {
   .products {
     margin-top: 10px;
   }
 }
 .products {
   padding: 20px 0;

   .cosmetics_banner {
     margin-bottom: 50px;
     img {
       max-width: 100%;
     }
   }
   .clickable {
     background-color: #47a3da;
   }
   .button_active {
     background-color: #1d4a92;
   }

   #filter_button {
     // margin: 20px 0;
     margin: 0 0 20px 0;
     display: flex;
     justify-content: center;
     button {
       font-size: 0.8em;
       color: #fff;
       padding: 5px 20px;
       border: 1px solid #fff;
       margin: 0;
     }
   }
   .prod_title {
     display: flex;
     justify-content: space-between;
     align-items: baseline;
     border-bottom: 5px solid #ccc;
     margin-bottom: 15px;
     font-family: sans-serif;
     color: #999;
     .prod_name {
       font-size: 1.5em;
     }
   }
   .prod_description {
     font-size: 0.8em;
   }
   .nintei {
     width: $page-width;
     display: flex;
     justify-content: space-between;
     margin-bottom: 10px;
   }
   .row {
     display: flex;
     flex-wrap: wrap;
     justify-content: flex-start;
     margin-bottom: 20px;

     div {
       width: 313px;
       // margin: 0 5px;
       // background-color: #eee;
       img {
         width: 313px;
       }
       p {
         padding: 10px;
         font-size: 0.7em;
       }
     }
     // & div:first-child {
       //     margin-left: 0;
       // }
   }

   .row_cosmetics {
     display: flex;
     flex-wrap: wrap;
     justify-content: flex-start;
     // justify-content: space-between;
     margin-bottom: 20px;

     div {
       margin: 0 10px;
       width: 220px;
       // margin: 0 5px;
       // background-color: #eee;
       img {
         width: 220px;
       }
       p {
         text-align: center;
         padding: 10px;
         font-size: 0.7em;
       }
       strong {
         font-family: sans-serif;
         font-size: 1em;
         display: block;
         color: #1C5A85;
       }
     }
   }
 }

 @media screen and (max-width: 600px) {
   .products {
     #filter_button {
       button {
         padding: 5px 5px;
         border: 1px solid #fff;
       }
     }
     padding: 10px;
     .nintei {
       flex-direction: column;
       // justify-content: none;
       img {
         width: 100vw;
       }
     }
     .row {
       flex-direction: column;
       div {
         margin: 0 auto;
       }
     }
     .row_cosmetics {
       justify-content: space-around;
       // flex-direction: column;
       div {
         // margin: 0 auto;
         /* width: 40%; */

         img {
           width: 100%;
         }
       }
     }
   }
 }
</style>
